import ULD from "@/models/ULD";
import api from "@/api";

const state = {
  LIST: { paging: {}, data: [] },
  ULD: {},
  SPAREPARTS: { paging: {}, data: [] },
  STOCKOUT_ITEMS: [],
  DAMAGE_DESCRIPTIONS: []
};
const getters = {
  info: state => {
    return state.ULD;
  },
  list: state => {
    return state.LIST;
  },
  spareParts: state => {
    return state.SPAREPARTS;
  },
  stockoutItems: state => {
    return state.STOCKOUT_ITEMS;
  },
  damageDescriptions: state => {
    return state.DAMAGE_DESCRIPTIONS;
  }
};
const actions = {
  async fetch({ commit, dispatch }, uld_id) {
    let data = await ULD.list({ id: uld_id });
    if (data) {
      let item = data.data[0];
      let info = new ULD({
        id: item.id,
        job_order_number: item.job_order_number,
        location_id: item.location ? item.location.id : "",
        station_id: item.station ? item.station.id : "",
        masterlist_id: item.masterlist.id,
        status_id: item.status.id,
        type: item.type,
        description: item.description,
        date_received: item.date_received,
        pre_inspection_date: item.pre_inspection_date,
        job_completed: item.job_completed,
        labor: item.labor,
        locked: item.locked ? true : false,
        materials: item.materials,
        damages: item.damages,
        customer: item.customer,
        pre_approved_by_id: item.pre_approver.id ? item.pre_approver.id : "",
        pre_approver: item.pre_approver.id ? item.pre_approver : {},
        supervisor: item.pre_approver.id ? item.pre_approver : {},
        supervisor_id: item.supervisor.id ? item.supervisor.id : "",
        supervisor: item.supervisor.id ? item.supervisor : {},
        mechanic_id: item.mechanic.userid ? item.mechanic.userid : "",
        mechanic: item.mechanic.userid ? item.mechanic : {},
        time_rendered: item.time_rendered,
        time_rendered_hours: item.time_rendered
          ? parseInt(item.time_rendered.split(":")[0])
          : 0,
        time_rendered_minutes: item.time_rendered
          ? parseInt(item.time_rendered.split(":")[1])
          : 0,
        collected_from: item.collected_from,
        cleaning_cost: item.cleaning_cost,
        remarks: item.remarks,
        rate: item.rate ? item.rate : 35,
        estimates: item.estimates ? item.estimates : null,
        ber: item.ber ? item.ber : 0.0,
        category: item.category
      });
      commit("SET_INFO", info);
      dispatch("fetchSpareParts", info.id);
      dispatch("fetchStockoutItems", info.id);
      return info;
    }
  },
  async delete({ commit }, payload) {
    const result = await api.put(`/api/v1/repair/delete/uld_out/${payload}/`);
    if (result && result.status == 200) {
      // commit("removeItem", payload);
      return result.data.data;
    }
    return null;
  },
  async fetchList({ commit }, params) {
    let list = await ULD.list(params);
    if (list) {
      commit("SET_LIST", list);
    }
  },
  async fetchSpareParts({ commit }, uld_id) {
    let list = await ULD.get_requested_parts({ uldin_id: uld_id });
    if (list) {
      commit("SET_SPAREPARTS", list);
    }
  },
  async fetchStockoutItems({ commit }, uld_id) {
    let list = await ULD.get_stockout_items({ uld_id: uld_id });
    if (list) {
      commit("SET_STOCKOUT_ITEMS", list);
    }
  },
  async fetchDamages({ commit }, uld_id) {
    let data = await ULD.list({ id: uld_id });
    if (data) {
      let item = data.data[0];
      commit("SET_DAMAGES", item.damages);
    }
  },
  deleteDamage({ commit }, damage_id) {
    if (damage_id) {
      commit("DELETE_DAMAGE", damage_id);
    }
  },
  setEstimates({ commit }, payload) {
    if (payload) {
      commit("SET_ESTIMATES", payload);
    }
  },
  async fetchDamageDescriptions({ commit }, params) {
    let data = await ULD.get_damage_descriptions(params);
    if (data) {
      commit("SET_DAMAGE_DESCRIPTIONS", data.data);
    }
  }
};
const mutations = {
  SET_INFO: (state, payload) => {
    state.ULD = payload;
  },
  SET_LIST: (state, payload) => {
    state.LIST = payload;
  },
  DELETE_DAMAGE: (state, payload) => {
    let damage = state.ULD.damages.find(o => o.id == payload);
    if (damage) {
      damage.deleted = 1;
    }
  },
  SET_SPAREPARTS: (state, payload) => {
    state.SPAREPARTS = payload;
  },
  SET_STOCKOUT_ITEMS: (state, payload) => {
    state.STOCKOUT_ITEMS = payload;
  },
  SET_DAMAGES: (state, payload) => {
    state.ULD.damages = payload;
  },
  SET_ESTIMATES: (state, payload) => {
    state.ULD.estimates = payload;
  },
  SET_DAMAGE_DESCRIPTIONS: (state, payload) => {
    state.DAMAGE_DESCRIPTIONS = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
